import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageManager } from '@cutting/main/shared/helper/local-storage-manager.helper';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfigService } from '@fuse/services/config.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { ActivateAccountBySmsCodeService } from './activate-account-by-sms-code.service';

@Component({
  selector: 'cutting-activate-account-by-sms-code',
  templateUrl: './activate-account-by-sms-code.component.html',
  styleUrls: ['./activate-account-by-sms-code.component.scss'],
  animations: fuseAnimations,
})
export class ActivateAccountBySmsCodeComponent implements OnInit, OnDestroy {
  phone = '';
  clientId = 0;
  timeSec = 0;
  public code: UntypedFormControl = new UntypedFormControl('', [
    Validators.required,
    Validators.minLength(6),
    Validators.maxLength(6),
  ]);
  private clockSubscription: Subscription;

  get userId(): number {
    return LocalStorageManager.regData;
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private fuseConfigService: FuseConfigService,
    private router: Router,
    private activateAccountBySmsCodeService: ActivateAccountBySmsCodeService,
    private snackBar: MatSnackBar
  ) {
    this.fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        toolbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        sidepanel: {
          hidden: true,
        },
      },
    };
  }

  ngOnInit(): void {
    this.getFromQueryParams();

    this.clockSubscription = this.activateAccountBySmsCodeService.getTimer().subscribe(time => (this.timeSec = time));
  }

  ngOnDestroy(): void {
    this.clockSubscription.unsubscribe();
  }

  getMinutes(secons: number): number {
    return Math.floor(secons / 60);
  }

  getFromQueryParams(): void {
    this.activatedRoute.queryParams.pipe(filter(params => params.phone || params.client)).subscribe(params => {
      if (params.phone) {
        this.phone = params.phone;
      }
      if (params.client) {
        this.clientId = params.client;
      }
    });
  }

  sendSmsCode(): void {
    this.activateAccountBySmsCodeService
      .activateClientBySmsCode(+this.code.value)
      .then(() => {
        if (this.userId) {
          this.router.navigate(['/client/auth/account-activated']);
        }
      })
      .catch(() => {
        this.snackBar.open($localize`Не удалось активировать учетную запись`);
      });
  }

  resendSmsCodeToClient(): void {
    this.activateAccountBySmsCodeService
      .resendSmsCode(this.clientId)
      .then(() => {
        this.snackBar.open($localize`SMS с кодом отправлено`);

        this.activateAccountBySmsCodeService.resetTimer();
      })
      .catch(() => {
        this.snackBar.open($localize`Не удалось отправить SMS с кодом`);
      });
  }
}
